import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { Reveal } from "../components/Reveal";

export default function Faq() {
  const { L } = useStore();
  const [open, setOpen] = useState(0);

  return (
    <div className="pt-32 pb-24 star-lattice min-h-screen" data-testid="faq-page">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="text-center">
          <Reveal><p className="eyebrow">{L.faq.eyebrow}</p></Reveal>
          <Reveal delay={0.08}><h1 className="font-display text-4xl sm:text-5xl text-ivory mt-4">{L.faq.title}</h1></Reveal>
        </div>
        <div className="mt-14 space-y-3">
          {L.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={0.04 * i}>
                <div className={"border rounded-2xl overflow-hidden transition-colors duration-300 " + (isOpen ? "border-gold/50 bg-onyx/80" : "border-gold/20 bg-onyx/40")} data-testid={"faq-item-" + i}>
                  <button
                    data-testid={"faq-question-" + i}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className={"font-display text-base lg:text-lg " + (isOpen ? "text-gold" : "text-ivory")}>{item.q}</span>
                    <ChevronDown className={"w-5 h-5 shrink-0 text-gold transition-transform duration-300 " + (isOpen ? "rotate-180" : "")} strokeWidth={1.5} />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <p className="px-6 pb-6 text-sm text-ivory/80 leading-relaxed" data-testid={"faq-answer-" + i}>{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  );
}
